import { UserRoleId } from '@/types/authorisation/role-id.enum'

const DYNAMIC_USER_ROLE_HIERARCHY_MAP = new Map()

export function generateUserRoleHierarchyMap() {
  const roles = Object.values(UserRoleId)

  const rolesLength = roles.length

  for (let i = 0; i < rolesLength; i++) {
    const roleId = roles[i]

    DYNAMIC_USER_ROLE_HIERARCHY_MAP.set(roleId, i)
  }
}

export function isRoleAllowed(currentUserRole: UserRoleId, allowedMinimumUserRole: UserRoleId): boolean {
  const currentHierarchyRole = DYNAMIC_USER_ROLE_HIERARCHY_MAP.get(currentUserRole)
  const minimumHierarchyRole = DYNAMIC_USER_ROLE_HIERARCHY_MAP.get(allowedMinimumUserRole)

  if (currentHierarchyRole === undefined || minimumHierarchyRole === undefined) {
    return false
  }

  return currentHierarchyRole <= minimumHierarchyRole
}
